import {createContext} from "react";

import {AsyncProcessState} from "../../../core/network/async-process/asyncProcessTypes";
import {AssetIconsJSON} from "../../util/assetModels";
import useFetchAssetIcons from "../util/useFetchAssetIcons";

const AssetIconContext = createContext<AsyncProcessState<AssetIconsJSON> | null>(null);

AssetIconContext.displayName = "AssetIconContext";

interface AssetIconContextProviderProps {
  children: React.ReactNode;
}

function AssetIconContextProvider({children}: AssetIconContextProviderProps) {
  const assetIcons = useFetchAssetIcons();

  return (
    <AssetIconContext.Provider value={assetIcons}>{children}</AssetIconContext.Provider>
  );
}

export default AssetIconContext;
export {AssetIconContextProvider};
